/**
 * Les créneaux de livraison proposés à la saisie, alignés sur ceux de la webapp client
 * (`systems/freefood-app/src/lib/orders/delivery-time.ts`) : pas de 30 min, début entre 07:00 et
 * 12:00, fin entre 09:00 et 18:00, et au moins 30 min d'écart.
 *
 * Un créneau de moins de 3 h est facturé au client (`verifyDeliveryPrice` côté API) : le formulaire le
 * signale plutôt que de l'interdire.
 */
const STEP_MINUTES = 30;

export const MIN_FREE_INTERVAL_HOURS = 3;
export const DEFAULT_DELIVERY_TIME_WINDOW = { start: '08:00', stop: '14:00' };

function buildTimeOptions(firstHour: number, lastHour: number): { value: string; label: string }[] {
    const options: { value: string; label: string }[] = [];

    for (let minutes = firstHour * 60; minutes <= lastHour * 60; minutes += STEP_MINUTES) {
        const value = `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`;
        options.push({ value, label: value });
    }

    return options;
}

export const DELIVERY_WINDOW_START_OPTIONS = buildTimeOptions(7, 12);
export const DELIVERY_WINDOW_STOP_OPTIONS = buildTimeOptions(9, 18);

export function getTimeInMinutes(time: string): number {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
}

export function getDeliveryWindowError(start: string, stop: string): string | null {
    return getTimeInMinutes(stop) - getTimeInMinutes(start) < STEP_MINUTES
        ? `La fin du créneau doit être au moins ${STEP_MINUTES} minutes après son début.`
        : null;
}

export function isDeliveryWindowCharged(start: string, stop: string): boolean {
    return getTimeInMinutes(stop) - getTimeInMinutes(start) < MIN_FREE_INTERVAL_HOURS * 60;
}
